//Enums
import ENUMS from "@/enums";
import "@/libs/acl";
import "@/libs/clipboard";
import i18n from "@/libs/i18n";
import "@/libs/portal-vue";
import "@/libs/sweet-alerts";
import "@/libs/toastification";
import "@/libs/tour";
//VeeValidate Rules
import "@/libs/vee-validate/vee-validate.js";
import "@/libs/vue-select";
// 3rd party plugins
import "@axios";
import VueCompositionAPI from "@vue/composition-api";
import { ModalPlugin, ToastPlugin } from "bootstrap-vue";
// Componente de máscara para os inputs
import VueMask from "v-mask";
import Vue from "vue";
// Google Analytics
import VueGtag from "vue-gtag";
import App from "./App.vue";
// Global Components
import "./global-components";
import router from "./router";
import store from "./store";

// Doc: https://matteo-gabriele.gitbook.io/vue-gtag/v/master/multiple-domain-tracking
Vue.use(VueGtag, {
  config: {
    // Abracaf Beta
    id: "G-NDQPY3G74B",
  },
  includes: [
    {
      // Abrare Beta
      id: "G-Z2SYVCB2C8",
    },
    {
      // Abcn Beta
      id: "G-LWDLRQ4Z0F",
    },
  ],
});

Vue.prototype.$ENUMS = ENUMS;

// BSV Plugin Registration
Vue.use(ToastPlugin);
Vue.use(ModalPlugin);

// Composition API
Vue.use(VueCompositionAPI);

Vue.use(VueMask);

// Feather font icon - For form-wizard
// * Shall remove it if not using font-icons of feather-icons - For form-wizard
require("@core/assets/fonts/feather/iconfont.css"); // For form-wizard

// import core styles
require("@core/scss/core.scss");

// import assets styles
require("@/assets/scss/style.scss");

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
